import React from "react";
import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { experienceData as fallback } from "./data";
import { useSectionsData } from "../../utils/useSectionsData.ts";
import { getBrandName } from "../../utils/helpers.ts";
import glideImage from "../../utils/useGlideImage.ts";

export interface ExperienceProps {
  tr_title: string;
  tr_description: string;
  icon: string;
}

export const Experience = () => {
  const sections = useSectionsData();
  const brandName = getBrandName();
  const productExperienceSection = sections?.pp_v7_experience_section;
  const heading = productExperienceSection?.tr_heading;
  const subheading = productExperienceSection?.tr_subheading;
  const productImage =
    productExperienceSection?.product_img ||
    `${window.template_root}/v1/AshwagandhaProductImage.png`;
  const experienceData: ExperienceProps[] =
    productExperienceSection?.product_experience_benefits?.length > 0
      ? productExperienceSection?.product_experience_benefits
      : fallback.map((item) => ({
          title: item.title,
          description: item.text,
          icon: item.img,
        }));

  return (
    <PageWrapper backgroundColor="section_light">
      <div className={s.experience}>
        <div
          className={s.experience__title}
          dangerouslySetInnerHTML={{ __html: heading }}
        ></div>
        {subheading && (
          <>
            <div className={s.experience__divider}></div>
            <div
              className={s.experience__subtitle}
              dangerouslySetInnerHTML={{ __html: subheading }}
            ></div>
          </>
        )}
        <div className={s.experience__content}>
          <div className={s.experience__content__row1}>
            {experienceData.slice(0, 2).map((item, index) => (
              <div key={index} className={s.experience__content__block}>
                <div className={s.experience__titleWrapper}>
                  <img src={item.icon} alt={brandName} width={64} height={64} />
                  <p dangerouslySetInnerHTML={{ __html: item.tr_title }} />
                </div>
                <span
                  className={s.experience__block__text}
                  dangerouslySetInnerHTML={{ __html: item.tr_description }}
                />
              </div>
            ))}
          </div>
          <img
            className={s.experience__productImg}
            src={glideImage(productImage, { w: 458, h: 458 })}
            alt={brandName}
            width={458}
            height={458}
          />
          <div className={s.experience__content__row3}>
            {experienceData.slice(-2).map((item, index) => (
              <div key={index} className={s.experience__content__block}>
                <div className={s.experience__titleWrapper}>
                  <img src={item.icon} alt={brandName} width={64} height={64} />
                  <p dangerouslySetInnerHTML={{ __html: item.tr_title }} />
                </div>
                <span
                  className={s.experience__block__text}
                  dangerouslySetInnerHTML={{ __html: item.tr_description }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};
